
import { bOne, bTwo, bThree, bFour, bFive, bSix, bSeven, mbOne, mbTwo, mbThree, mbFour, mbFive, mbSix, mbSeven } from "../../assets"

export const data = [
    {
        img: bOne,
    },
    {
        img: bTwo,
    },
    {
        img: bThree,
    },
    {
        img: bFour,
        style: {
            height: "250px"
        }
    },
]

export const dataDown = [
    {
        img: bSeven,
    },
    {
        img: bSix,
    },
    {
        img: bFive,
    },
]

export const mobileData = [
    {
        img: mbOne,
    },
    {
        img: mbTwo,
    },
    {
        img: mbThree,
    },
    {
        img: mbFour,
    },
    {
        img: mbFive,
    },
    {
        img: mbSix,
    },
    {
        img: mbSeven,
    }
]